import { TransferFeesType } from '../types'

export interface Fee {
  type: string
  chargeToCorrespondent: boolean
}

export const getFeeOverrideDetails = (fees: TransferFeesType): Fee[] => {
  let feeOverrideDetails = []
  for (const fee in fees) {
    feeOverrideDetails.push({
      type: fee,
      chargeToCorrespondent: !fees[fee].chargeCustomer
    })
  }
  return feeOverrideDetails
}
